function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M133.69 274.264c0 18.77 15.217 33.987 33.988 33.987 18.77 0 33.988-15.217 33.988-33.987 0-18.772-15.218-33.988-33.988-33.988s-33.988 15.216-33.988 33.988m149.465-169.235s-17.565 38.894 6.064 56.25c0 0 30.948-2.3 28.02-51.86 0 0-9.41 3.346-17.146 1.256-7.738-2.09-16.938-5.646-16.938-5.646",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M366.003 219.203s3.765-12.548-18.192-20.076c-21.122-7.242-44.555-22.034-46.305-42.555 9.963-8.057 16.63-22.485 16.63-38.997 0-5.114-.754-9.797-1.814-14.092-2.325-9.432-9.46-17.018-11-18.398a32.172 32.172 0 0 0-13.751-7.289c-.876-.218-1.763-.4-2.662-.547 0 0-3.215-.887-8.943-.29-17.655 1.697-31.462 16.813-31.462 40.616 0 16.512 6.666 30.94 16.631 38.997-1.752 20.52-24.688 36.968-46.306 42.555-17.096 4.417-15.682 18.561-15.682 18.561m61.988-61.116s17.64 11.813 36.37 0",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M248.77 112.138s11.121-15.211 33.287-7.265c22.166 7.945 27.968 7.422 35.078 3.24m-62.672 70.94l16.938 16.937 10.664-10.664 11.292 11.292 18.82-18.82",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M290.717 120.126a8.625 8.625 0 0 0 8.625 8.625 8.625 8.625 0 1 0 0-17.25 8.626 8.626 0 0 0-8.625 8.625zm-28.394 0a8.625 8.625 0 0 0 8.625 8.625 8.626 8.626 0 1 0-8.625-8.625zm28.394 0s-5.626-3.983-11.142 0m-17.252 0l-13.73-5.813m59.297 4.662l10.081-5.562",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M22.508 135.428c0 4.823 6.096 8.732 13.615 8.732 7.52 0 13.614-3.91 13.614-8.732 0-4.822-6.095-8.731-13.614-8.731-7.52 0-13.615 3.909-13.615 8.731",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M25.178 136.954c0 4.822 6.096 8.731 13.614 8.731 7.52 0 13.615-3.909 13.615-8.731 0-4.823-6.096-8.732-13.615-8.732-7.518 0-13.614 3.91-13.614 8.732z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M25.178 136.954v8.074c0 4.823 6.096 8.732 13.614 8.732 7.52 0 13.615-3.909 13.615-8.732v-8.074",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M27.308 187.664l-1.369-9.967 11.336-5.864 14.658 3.91 1.173 9.185-10.359 7.653z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M29.588 188.185l-.585-9.967 10.552-5.864 14.659 3.909 1.172 9.186-10.359 8.06z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M55.388 185.318v7.558l-10.166 8.061-15.44-5.324-.194-7.427m15.44 5.324l.194 7.427"
}), React.createElement("path", {
  d: "M42.025 69.141S25.442 81.12 26.043 81.12l18.53 14.057-2.548-26.036z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M44.25 70.81S27.667 82.788 28.268 82.788l18.53 14.057L44.25 70.81z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M46.798 96.846v7.882L28.268 90.67v-7.882V88.4"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M138.574 280.456H2.367V56.367h175.161v184.56M70.866 88.985h78.284m-78.284 51.619h78.284m-78.284 45.258h78.284m-76.968 53.25h76.327"
}), React.createElement("path", {
  d: "M138.051 275.02c0 19.012 15.411 34.423 34.424 34.423 19.01 0 34.421-15.411 34.421-34.423 0-19.01-15.411-34.422-34.421-34.422-19.013 0-34.424 15.411-34.424 34.422z",
  stroke: "#2E388E",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M149.094 274.68l16.439 16.439 30.411-30.411"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M26.425 233.722l13.8 10.694 16.493-12.073-13.776-10.811z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M29.089 233.722l13.8 10.694 16.493-12.073-13.776-10.811zm30.681-1.28l.021 8.823c-.096.042-16.69 12.12-16.69 12.12"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M28.716 233.575v8.61l14.171 10.841v-8.68"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 370 370",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide_7.svg